export default __webpack_public_path__ + "static/media/wsrs_UuaSd.c87f5501.png";